import { Component, Input } from '@angular/core';

@Component({
  selector: 'render-trademarks',
  template: `
    <span *ngIf="trademark">
      <sup *ngIf="trademark === 'R'">&reg;</sup>
      <sup *ngIf="trademark === 'TM'">&trade;</sup>
      <sup *ngIf="trademark === 'SM'">&#8480;</sup>
    </span>
  `,
  styles: [],
})
export class TrademarkRendererComponent {
  @Input() trademark: string;
}
